import React from 'react';
import PropTypes from 'prop-types';

import { Box, Body } from '@nerdwallet/currency';
import classNames from 'classnames';

import styles from './carousel.module.less';

const NerdCarousel = ({
  isImage,
  imageUrl,
  imageAlt,
  nerdName,
  nerdTitle,
  nerdDescription,
  darkBackground,
}) => {
  const carouselBackgroundImg = { backgroundImage: `url(${imageUrl})` };

  const nerdBoxOutput = (
    <Box
      className={classNames(styles.nerdCarouselTileOuter, {
        [styles.darkBackground]: darkBackground,
      })}
      display="flex"
      alignItems="stretch"
    >
      <Box
        className={styles.nerdCarouselTileInner}
        display="flex"
        borderLeft="1"
        borderTop="1"
        borderColor="neutral-lighter"
        borderRadius="2"
        shadow="1"
        alignItems="stretch"
        justifyContent="space-between"
      >
        <Body className={styles.nerdDescription}>
          <span className={styles.nerdQuotation}>&#x201c;</span>
          {nerdDescription}
        </Body>
        <Body className={styles.nerdName} size="small" bold>
          {nerdName},
          <br />
          {nerdTitle}
        </Body>
      </Box>
    </Box>
  );

  const mobileOutput = !isImage ? (
    nerdBoxOutput
  ) : (
    <div
      className={styles.nerdCarouselImgMobile}
      style={carouselBackgroundImg}
      title={imageAlt}
    />
  );

  const desktopOutput = (
    <React.Fragment>
      {nerdBoxOutput}
      <div
        className={styles.nerdCarouselImgDesktop}
        style={carouselBackgroundImg}
        title={imageAlt}
      />
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <Box className={styles.nerdCarouselTileMobile}>{mobileOutput}</Box>
      <Box className={styles.nerdCarouselTileDesktop}>{desktopOutput}</Box>
    </React.Fragment>
  );
};

NerdCarousel.propTypes = {
  isImage: PropTypes.bool,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  nerdName: PropTypes.string,
  nerdTitle: PropTypes.string,
  nerdDescription: PropTypes.string,
  darkBackground: PropTypes.bool,
};

NerdCarousel.displayName = 'Nerd Carousel Tile';

export default NerdCarousel;
